import AppIcons from "../../components/Base/AppIcons";
import { lazy } from "react";

import { enumPermisosPinesColpatriaCRC } from "../../apps/PinesCrc/enumPermisosPinesColpatriaCRC";
import { enumPermisosAgrarioGestion } from "../../apps/Corresponsalia/CorresponsaliaBancoAgrario/enumPermisosAgrario";
import { ListRoutesPasarelaAsignacionQrsModuleReportes } from "../../apps/PasarelaAsignacionQr/routes";
import { enumPermisosCrediBanco } from "../../apps/CrediBanco/enumPermisosCrediBanco";

const Koncilia = lazy(() => import("./views/Koncilia"));
const ReporteComercios = lazy(() => import("./views/ReporteComercios"));
const ReporteUsuarios = lazy(() => import("./views/ReporteUsuarios"));
const ReporteComisiones = lazy(() => import("./views/ReporteComisiones"));
const ReporteConteoComisiones = lazy(() =>
  import("./views/ReporteConteoComisiones")
);
const ReporteComisionesComercios = lazy(() =>
  import("./views/ReporteComisionesComercios")
);
const ReporteConsignacionesTransportadora = lazy(() =>
  import("./views/ReporteConsignacionesTransportadora")
);
const ReporteGeneralPinesCRCColpatria = lazy(() =>
  import("./views/ReporteGeneralPinesCRCColpatria")
);
const ReporteDispersionPinesColpatriaCRC = lazy(() =>
  import("./views/ReporteDispersionPinesColpatriaCRC")
);
const ReporteDeComercios = lazy(() => import("./views/ReporteDeComercios"));
const ReportesComisionesPadres = lazy(() =>
  import("./views/ReportesComisionesPadres")
);
const ReporteMovimientoPasarela = lazy(() =>
  import("./views/ReporteMovimientoPasarela")
);
const ReporteComerciosTerminalesBCS = lazy(() =>
  import("./views/ReporteComerciosTerminalesBCS")
);
const ReporteComerciosItau = lazy(() => import("./views/ReporteComerciosITAU"));
const ReportePinesOlimpia = lazy(() => import("./views/ReportePinesOlimpia"));
const ReportePinesCeaOlimpia = lazy(() =>
  import("./views/ReportePinesCeaOlimpia")
);
const ReporteTransaccionesCredibanco = lazy(() =>
  import("./views/ReporteCredibanco")
);

const ReporteEstadoTransaccionesTransfiya = lazy(() =>
  import("./views/ReporteEstadoTransaccionesTransfiya")
);

const ReportePunteoElectronico = lazy(() =>
  import("./views/ReportePunteoElectronico")
);

export const rutasReportes = [
  {
    link: "/reportes/koncilia",
    label: <AppIcons Logo={"RECAUDO"} name="Reportes koncilia" />,
    component: Koncilia,
    permission: [40],
  },
  // {
  //   link: "/reportes/comercios",
  //   label: <AppIcons Logo={"RECAUDO"} name="Reportes comercio" />,
  //   component: ReporteComercios,
  //   permission: [25001],
  // },
  // {
  //   link: "/reportes/comisiones",
  //   label: <AppIcons Logo={"RECAUDO"} name="Reportes comisiones" />,
  //   component: ReporteComisiones,
  //   permission: [42],
  // },
  // {
  //   link: "/reportes/conteo-comisiones",
  //   label: <AppIcons Logo={"RECAUDO"} name="Reportes conteo comisiones" />,
  //   component: ReporteConteoComisiones,
  //   permission: [42],
  // },
  // {
  //   link: "/reportes/comisiones-comercio",
  //   label: <AppIcons Logo={"RECAUDO"} name="Reportes comisiones comercio" />,
  //   component: ReporteComisionesComercios,
  //   permission: [25001],
  // },
  {
    link: "/reportes/consignaciones_transportadora",
    label: (
      <AppIcons
        Logo={"RECAUDO"}
        name="Reporte Consignaciones y Transportadora"
      />
    ),
    component: ReporteConsignacionesTransportadora,
    permission: [25003],
  },
  // {
  //   link: "/reportes/comercios_general",
  //   label: <AppIcons Logo={"RECAUDO"} name="Reporte de comercios" />,
  //   component: ReporteDeComercios,
  //   permission: [25007],
  // },
  // {
  //   link: "/reportes/comisiones-usuario-padre",
  //   label: <AppIcons Logo={"RECAUDO"} name="Reporte comisiones hijos" />,
  //   component: ReportesComisionesPadres,
  //   permission: [25001],
  // },
  // {
  //   link: "/reportes/movimientos_pasarela",
  //   label: <AppIcons Logo={"RECAUDO"} name="Reporte Pasarelas" />,
  //   component: ReporteMovimientoPasarela,
  //   permission: [27013],
  // },
  // ...ListRoutesPasarelaAsignacionQrsModuleReportes,
  {
    link: "/reportes/usuarios",
    label: <AppIcons Logo={"RECAUDO"} name="Reporte usuarios" />,
    component: ReporteUsuarios,
    permission: [25002],
  },
  {
    link: "/reportes/reporte_general_pines_crc_colpatria",
    label: (
      <AppIcons Logo={"RECAUDO"} name="Reporte General Pines OAT Colpatria" />
    ),
    component: ReporteGeneralPinesCRCColpatria,
    permission: [enumPermisosPinesColpatriaCRC.REPORTE_GENERAL_PIN_CRC],
  },
];
